import {createContext} from "react";

export interface ScrollableViewState {
    scrollToTop: () => void;

    scrollToBottom: () => void;
}

export const ScrollableViewContext = createContext<ScrollableViewState>({
    scrollToTop: () => {
        /**/
    },
    scrollToBottom: () => {
        /**/
    },
});

